import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LegalFees, WireInstructions } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UpdateLegalFeesWireInstructionsRequest {
    engagementId: number;
    instructions: WireInstructions;
}

export const UpdateLegalFeesWireInstructions = createAsyncThunk(
    'flowOfFunds/updateLegalFeesWireInstructions',
    async (params: UpdateLegalFeesWireInstructionsRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/legalFees/wireInstructions`,
                params.instructions
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the wire instructions');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not save the wire instructions.', 'error');
            throw error;
        }
    }
);
